import React from "react";
import EventEmitter from "../../../services/event-emitter";

function changeSection(e, section) {
  e.preventDefault();

  const eventemitter = EventEmitter.getInstance();
  eventemitter.trigger("team-reports-go-to-section", [section]);
}

function TeamReportsCard({ section = 1, title = "", active = false }) {
  const cardClassName =
    active === true ? "team-reports-card active" : "team-reports-card";

  return (
    <a
      href="/#"
      className={cardClassName}
      onClick={e => {
        changeSection(e, section);
      }}
    >
      <span className="title">
        <span className="title-inner">{title}</span>
      </span>
    </a>
  );
}

export default TeamReportsCard;



// WEBPACK FOOTER //
// ./src/components/team-reports/navigation/card.js